import { render, staticRenderFns } from "./BlockParagraphPic.vue?vue&type=template&id=6a6a6c08&"
import script from "./BlockParagraphPic.vue?vue&type=script&lang=js&"
export * from "./BlockParagraphPic.vue?vue&type=script&lang=js&"
import style0 from "./BlockParagraphPic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports